import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';
import { FreeMode, Pagination } from 'swiper/modules';
import Footer from './Footer';
import { NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Home = () => {
  const divData = [
    {
      content:
        '"Working with Lotez has been a game-changer for our business. Their team helped us develop a custom software solution that streamlined our operations and improved overall efficiency. The user experience design was spot on, and the product is exactly what we envisioned. Their attention to detail and customer-centric approach made the entire process seamless. We highly recommend Lotez for any business looking to elevate their digital presence!"',
      name: 'LocalFox',
    },
    /*{
      content:
        '"As a startup, we needed a team that could not only help us build our product but also guide us through the technical and digital strategy. Lotez delivered on all fronts. They developed an intuitive app, helped us fine-tune our digital strategy, and provided us with ongoing support. Their team truly feels like an extension of ours, and we\'re thrilled with the results. Lotez is the perfect partner for any startup!"',
      name: 'XnY',
    },*/
    {
      content:
        '"We approached Lotez to assist with our enterprise software development, and we couldn\'t be happier with the results. They crafted a solution tailored to our complex business needs, integrating advanced technologies seamlessly. The final product exceeded our expectations, and their continued support has been invaluable. Their innovative approach and technical expertise are unmatched. Lotez is an integral part of our success!"',
      name: 'Rentoany',
    },
  ];
  return (
    <>
      <div className="bg-homeColor min-w-[280px] max-w-screen mx-auto">
        <div className="bg-homeColor h-screen text-white flex flex-col items-center ">
          <h1 className="mt-40 lg:mt-52 text-3xl sm:text-5xl font-bold text-center">
            Innovating Your Business with{' '}
            <span className="text-green">Technology</span>
          </h1>
          <p className="text-base sm:text-xl mt-4 text-center w-4/5 sm:w-3/5">
            Empowering your business with innovative technology solutions that
            drive growth, efficiency, and success in the digital world.
          </p>
          <div className="lg:w-[30%] mt-8 flex flex-col sm:flex-row lg:flex-row gap-7">
            <button className="bg-green  hover:border-homeColor text-homeColor w-full  lg:w-[80%] border-2 border-green font-semibold rounded-3xl px-8 py-2">
              <HashLink
                to="#services"
                scroll={(el) =>
                  el.scrollIntoView({ behavior: 'smooth', block: 'start' })
                }
              >
                Get Started
              </HashLink>
            </button>

            <button className="bg-green text-homeColor hover:border-homeColor w-full  lg:w-[80%] border-2 border-green font-semibold rounded-3xl px-8 py-2">
              <NavLink to="/contact">Contact Us</NavLink>
            </button>
          </div>
        </div>
        <div
          id="services"
          className="bg-homeColor  w-full text-white flex flex-col items-center scroll-mt-20 "
        >
          <h1 className="text-center text-4xl font-bold ">
            Our <span className="text-green">Services</span>
          </h1>
          <p className="text-center mt-3 text-base w-3/5 sm:w-3/5 sm:text-xl">
            We have been assisting businesses of all sizes in transforming their
            operations into innovative digital solutions.
          </p>
          <div className="mt-8  flex flex-row gap-x-4 gap-y-7 flex-wrap w-full justify-center">
            <div className=" bg-cardColor overflow-x-hidden w-[90%]  sm:w-[80%] lg:w-[30%] p-9 border-2 border-customGray rounded-2xl  ">
              <h2 className=" mt-3 font-bold text-2xl">Software Development</h2>

              <p className=" mt-4 text-#d7f8f3 text-base w-7p">
                We offer custom software development services designed to meet
                the unique needs of your business. Our experienced team builds
                tailored solutions that streamline operations, improve
                efficiency, and drive growth. Whether it's a desktop
                application, enterprise software, or complex system integration,
                we use the latest technologies to deliver scalable, secure, and
                high-performing software that aligns with your goals.
              </p>
            </div>
            <div className=" bg-cardColor w-[90%] sm:w-[80%] lg:w-[30%] p-9 border-2 rounded-2xl ">
              <h2 className=" mt-3 font-bold text-2xl ">Web Development</h2>
              <p className=" mt-4 text-#d7f8f3 text-base w-7p">
                We specialize in web development solutions that are tailored to
                your business goals. From simple websites to complex web
                applications, we deliver responsive, scalable, and secure
                solutions that enhance user experience and drive results. Our
                team leverages the latest technologies to build websites that
                are fast, mobile-friendly, and easy to navigate, ensuring your
                online presence is impactful and engaging.
              </p>
            </div>
            <div className=" bg-cardColor w-[90%] sm:w-[80%] lg:w-[30%] p-9 border-2 rounded-2xl ">
              <h2 className=" mt-3 font-bold text-2xl ">
                Mobile App Development
              </h2>
              <p className=" mt-4 text-#d7f8f3 text-base w-7p">
                We offer expert mobile app development services, creating custom
                solutions for iOS and Android platforms. Our team designs and
                develops intuitive, high-performance apps tailored to your
                business needs. From concept to deployment, we ensure seamless
                functionality, engaging user experiences, and robust security.
                Whether you're launching a new app or improving an existing one.
              </p>
            </div>

            <div className=" bg-cardColor  w-[90%] sm:w-[80%] lg:w-[30%] p-9 border-gray-300 border-2 shadow-2xl rounded-2xl ">
              <h2 className=" mt-3 font-bold text-2xl ">UI/UX Design</h2>
              <p className=" mt-4 text-#d7f8f3 text-base w-7p">
                We specialize in UI/UX design that focuses on creating
                intuitive, engaging, and user-friendly experiences. Our design
                process begins with in-depth user research to understand your
                audience's needs, followed by wireframing, prototyping, and
                testing to ensure a seamless interface. We prioritize
                functionality, aesthetics, and usability, delivering designs
                that drive user satisfaction and increase engagement.
              </p>
            </div>
            <div className=" bg-cardColor w-[90%] sm:w-[80%] lg:w-[30%] p-9 border-2 rounded-2xl ">
              <h2 className=" mt-3 font-bold text-2xl ">SEO & SMM</h2>
              <p className=" mt-4 text-#d7f8f3 text-base w-7p">
                We help you grow your online presence and drive targeted traffic
                with our expert SEO and Social Media Marketing services. Our SEO
                strategies are designed to improve your website's visibility on
                search engines, ensuring your business ranks higher and attracts
                more organic traffic. We create engaging content, run targeted
                ad campaigns, and build a strong social media presence to
                increase brand awareness and boost conversions.
              </p>
            </div>
            <div className=" bg-cardColor w-[90%] sm:w-[80%] lg:w-[30%] p-9 border-2 rounded-2xl ">
              <h2 className=" mt-3 font-bold text-2xl ">
                Telecom VAS Integrations
              </h2>
              <p className=" mt-4 text-#d7f8f3 text-base w-7p">
                We provide seamless Telecom Value-Added Services (VAS)
                integrations that enhance communication and customer
                experiences. Our solutions integrate advanced services like SMS,
                IVR, USSD, and mobile payments, ensuring smooth connectivity and
                improved service delivery. Tailored to meet your business needs,
                our VAS integrations drive efficiency, boost customer
                engagement, and maximize revenue opportunities.
              </p>
            </div>
          </div>
        </div>
        <div className="bg-homeColor  mt-32 text-white flex flex-col mb-10 items-center">
          <h1 className="text-center text-4xl font-bold ">
            Our <span className="text-green">Happy Clients</span>
          </h1>
          <p className="text-center mt-3 text-base w-3/5 sm:w-3/5 sm:text-xl">
            We have been helping small to large businesses transform their
            businesses into digital products.
          </p>
        </div>
        <div className="flex items-center overflow-x-hidden justify-center flex-col h-fit bg-cardColor">
          <Swiper
            breakpoints={{
              340: {
                slidesPerView: 1,
                centeredSlides: true,
                
              },
              496: {
                slidesPerView: 1,
                spaceBetween: 5,
                centeredSlides: true,
              },
              700: {
                slidesPerView: 2,
                spaceBetween: 15,
                centeredSlides: false,
              },
            }}
            freeMode={true}
            pagination={{
              clickable: true,
            }}
            modules={[FreeMode, Pagination]}
            className="max-w-[90%] lg:max-w-[80%]"
          >
            {divData.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="flex flex-col   gap-2  mb-20 group relative shadow-lg text-white rounded-xl px-6 py-8 h-auto max-w-[95%]  sm:max-w-[90%] lg:max-w-[90%]  overflow-hidden cursor-pointer">
                  <div className="absolute inset-0 bg-cover bg-center" />
                  <div className="absolute inset-0 bg-green opacity-10 group-hover:opacity-50" />
                  <div className="relative flex flex-col gap-3">
                    <h1 className="text-xl  lg:text-2xl">{item.name}</h1>
                    <p className="lg:text-[18px]">{item.content}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {/*<div className="flex flex-col  mt-20 items-center text-white">
          <h1 className="text-center text-4xl font-bold ">
            Ready to Boost
            <br /> Your
            <span className="text-green ml-4">Digital Presence?</span>
          </h1>
          <p className="text-center mt-3 text-base w-3/5 sm:w-3/5 sm:text-xl">
            Whether you're a startup ready to make your mark or an established
            business aiming to amplify your digital strategy, our team is here
            to guide you.
          </p>
          <div className="flex flex-row flex-wrap gap-4 mt-20 w-full items-center justify-center">
            <input
              className="text-lg text-left w-[90%] sm:w-[80%] lg:w-[40%] shadow appearance-none border-gray-300 hover:border-2 hover:border-green focus:border-green focus:outline-none px-4 sm:px-2 py-4 rounded-3xl bg-cardColor"
              type="text"
              placeholder="Your Email"
            />
            <button className="w-[90%] sm:w-[80%] lg:w-[20%] text-homeColor bg-green border-green font-semibold rounded-3xl px-8 py-2">
              Get Started
            </button>
          </div>
        </div>*/}
        <Footer />
      </div>
    </>
  );
};
export default Home;
